import { render, staticRenderFns } from "./PickOrder.vue?vue&type=template&id=577425e7"
import script from "./PickOrder.vue?vue&type=script&lang=js"
export * from "./PickOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports